import React from "react";

/**
 * Slim progress bar for project rows. Fill colour tracks completion:
 * cool teal until near-done, sage green when finished.
 */
export default function ProjectProgressBar({ value = 0, className = "" }) {
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  const fill = pct >= 100 ? "#81B29A" : "#14B8A6";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="project-progress-bar">
      <div className="relative flex-1 h-2 rounded-full bg-[#EBE5D9] overflow-hidden">
        <div
          className="h-full rounded-full transition-[width]"
          style={{ width: `${pct}%`, background: fill }}
        />
      </div>
      <span
        className="text-xs font-semibold tabular-nums text-[#2C2A29] min-w-[36px] text-right"
        data-testid="project-progress-value"
      >
        {pct}%
      </span>
    </div>
  );
}
